// import React from "react";
// import "./About_Section.css";
// import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

// const About = () => {
//   return (
//     <section className="about-section">
//       <div className="container about-section-container">
//         <div className="row">
//           <div className="col-12">
//             {/* <div className="about-heading text-center">
//               <span className="about-tag">Who We Are</span>

//               <h2>About Lkaumoduki</h2>

//               <p>Your trusted global recruitment partner since 2008</p>
//             </div> */}
//             <CommonHeading
//               badge="Who We Are"
//               title="About Lkaumoduki"
//               description="Your trusted global recruitment partner since 2008"
//             />
//           </div>
//         </div>

//         <div className="row align-items-start">
//           <div className="col-lg-4 col-md-5 col-12">
//             <div className="founder-card">
//               <div className="founder-image">
//                 <img
//                   src="/assets/images/logo/footer-logo.png"
//                   alt="Ram Pramod Patel"
//                 />
//               </div>

//               <div className="founder-details">
//                 <h3>Ram Pramod Patel</h3>

//                 <h4>Founder &amp; Director</h4>

//                 <p>
//                   With 15+ years of experience in overseas recruitment, leading
//                   New Adarsh with a commitment to ethical practices and
//                   transparent operations.
//                 </p>

//                 <div className="founder-email">
//                   <span className="email-icon">✉</span>
//                   <span>rampramodpatel1986@gmail.com</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-8 col-md-7 col-12">
//             <div className="about-info">
//               <h3>Your Trusted Global Recruitment Partner</h3>

//               <p>
//                 LKAUMODUKI INTERNATIONAL PVT LTD is an MEA-approved, Government
//                 of India licensed overseas manpower recruitment agency
//                 headquartered in Deoria Sadar, Uttar Pradesh. With over 15 years
//                 of experience, we specialize in connecting skilled Indian
//                 professionals with trusted international employers.
//               </p>

//               <p>
//                 Our mission is to facilitate seamless, legal, and transparent
//                 overseas recruitment. We maintain the highest standards of
//                 compliance with MEA regulations across Gulf, Middle East,
//                 Europe, and Asia.
//               </p>

//               {/* Stats */}
//               <div className="row about-stats">
//                 <div className="col-lg-3 col-md-6 col-6">
//                   <div className="stat-card">
//                     <strong>1000+</strong>
//                     <span>Placements</span>
//                   </div>
//                 </div>

//                 <div className="col-lg-3 col-md-6 col-6">
//                   <div className="stat-card">
//                     <strong>50+</strong>
//                     <span>Countries</span>
//                   </div>
//                 </div>

//                 <div className="col-lg-3 col-md-6 col-6">
//                   <div className="stat-card">
//                     <strong>100%</strong>
//                     <span>Legal</span>
//                   </div>
//                 </div>

//                 <div className="col-lg-3 col-md-6 col-6">
//                   <div className="stat-card">
//                     <strong>15+</strong>
//                     <span>Years</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Registration */}
//               <div className="registration-box">
//                 <div className="registration-title">
//                   <span className="registration-icon">⬟</span>

//                   <strong>MEA Registered &amp; Government Approved</strong>
//                 </div>

//                 <p>
//                   Fully compliant with Ministry of External Affairs regulations
//                   and Government of India licensing.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About;

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faBriefcase,
  faGlobe,
  faShieldHalved,
  faCalendarCheck,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

import "./About_Section.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const About = () => {
  const companyStats = [
    {
      value: "1000+",
      label: "Successful Placements",
      icon: faBriefcase,
    },
    {
      value: "50+",
      label: "Countries Served",
      icon: faGlobe,
    },
    {
      value: "100%",
      label: "Legal & Transparent",
      icon: faShieldHalved,
    },
    {
      value: "15+",
      label: "Years of Experience",
      icon: faCalendarCheck,
    },
  ];

  const companyHighlights = [
    "MEA-approved overseas manpower recruitment agency",
    "Government of India licensed recruitment operations",
    "Skilled professionals connected with trusted employers",
    "Transparent and compliant recruitment process",
  ];

  return (
    <section className="about-section">
      <div className="container about-section-container">
        {/* ================= HEADING ================= */}
        <div className="row">
          <div className="col-12">
            <div className="about-main-heading">
              <CommonHeading
                badge="Who We Are"
                title="Building Careers Beyond Borders"
                description="Your trusted global recruitment partner since 2008"
              />
            </div>
          </div>
        </div>

        {/* ================= MAIN ABOUT ================= */}
        <div className="row align-items-stretch about-main-row">
          {/* ================= FOUNDER ================= */}

          {/* ================= COMPANY INFORMATION ================= */}
          <div className="col-lg-12 col-12 mb-2">
            <div className="company-about-card">
              <div className="company-intro">
                <span className="section-label">About KAUMODAKI</span>

                <h3>
                  Connecting Indian Talent With
                  <span> Global Opportunities</span>
                </h3>

                <p>
                  KAUMODUKI INTERNATIONAL PVT LTD is an MEA-approved, Government
                  of India licensed overseas manpower recruitment agency
                  headquartered in Deoria Sadar, Uttar Pradesh.
                </p>

                <p>
                  With over 15 years of experience, we specialize in connecting
                  skilled Indian professionals with trusted international
                  employers across Gulf, Middle East, Europe and Asia.
                </p>
              </div>

              {/* ================= HIGHLIGHTS ================= */}
              <div className="company-highlights">
                <h4>What We Stand For</h4>

                <div className="highlight-list">
                  {companyHighlights.map((item, index) => (
                    <div className="highlight-item" key={index}>
                      <span className="highlight-icon">
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>

                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* ================= STATS ================= */}
              <div className="company-stats">
                {companyStats.map((stat, index) => (
                  <div className="company-stat" key={index}>
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={stat.icon} />
                    </div>

                    <div className="stat-content">
                      <strong>{stat.value}</strong>
                      <span>{stat.label}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="compliance-card">
                <div className="compliance-icon">
                  <FontAwesomeIcon icon={faShieldHalved} />
                </div>

                <div className="compliance-content">
                  <strong>MEA Registered & Government Approved</strong>

                  <p>
                    Fully compliant with Ministry of External Affairs
                    regulations and Government of India licensing requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
<div className="row justify-content-center">
          <div className="col-lg-4 col-12 mb-2">
            <div className="founder-profile-card">
              <div className="founder-profile-top">
                <span className="profile-label">Founder & Director</span>

                <div className="founder-image">
                  <img
                    src="/assets/images/avatars/director_img.jpg"
                    alt="Ram Pramod Patel"
                  />
                </div>
              </div>

              <div className="founder-profile-details">
                <h3>Mr.Sanjay Vishwakarma</h3>

                <p className="founder-role">Founder & Director</p>

                <p className="founder-description">
                  With 15+ years of experience in overseas recruitment, leading
                  KAUMODUKI INTERNATIONAL PVT LTD with a commitment to ethical
                  practices, transparent operations and professional career
                  opportunities.
                </p>

                <div className="founder-contact">
                  <span className="founder-contact-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>

                  <div>
                    <small>Email</small>
                    <a href="mailto:kumar@lkaumodaki.com">
                      kumar@lkaumodaki.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-12 mb-2">
            <div className="founder-profile-card">
              <div className="founder-profile-top">
                <span className="profile-label">Business Development manager</span>

                <div className="founder-image">
                  <img
                    src="/assets/images/avatars/managers_img.jpg"
                    alt="Ram Pramod Patel"
                  />
                </div>
              </div>

              <div className="founder-profile-details">
                <h3>Harshal T Desai</h3>

                <p className="founder-role">Business Development manager</p>

                <p className="founder-description">
                  With 10+ years of experience in overseas recruitment, leading
                  with a commitment to ethical practices, transparent operations
                  and professional career opportunities.
                </p>

                <div className="founder-contact">
                  <span className="founder-contact-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>

                  <div>
                    <small>Email</small>
                    <a href="mailto:kumar@lkaumodaki.com">bdm@lkaumodaki.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
